import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import InputText from "../../inputs/yup/materialui/inputText";

// Interfaz genérica para los datos del formulario
export interface FormData {
  [key: string]: string;
}

export interface FormConfirmationModalProps<T extends FormData = FormData> {
  open: boolean;
  title: string;
  subtitle?: string;
  confirmText: string;
  cancelText: string;
  onClose: () => void;
  onConfirm: (data: T) => void;
  showInput?: boolean;
  inputName?: string;           // Nombre del campo (key del objeto)
  inputLabel?: string;          // Label que se muestra en el input
  inputPlaceholder?: string;    // Placeholder del input
  defaultValue?: string;        // Valor por defecto
  required?: boolean;           // Si el campo es requerido
}

export default function FormConfirmationModal<T extends FormData = FormData>({
  open,
  title,
  subtitle,
  confirmText,
  cancelText,
  onClose,
  onConfirm,
  showInput = true,
  inputName = "value",
  inputLabel = "Valor",
  inputPlaceholder,
  defaultValue = "",
  required = false
}: FormConfirmationModalProps<T>) {
  
  const { control, handleSubmit, formState: { errors } } = useForm<FormData>({
    defaultValues: { [inputName]: defaultValue }
  });

  const onSubmitForm = (data: FormData) => {
    onConfirm(data as T);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {subtitle && (
          <Typography variant="body1" sx={{ mb: 2 }}>
            {subtitle}
          </Typography>
        )}

        {showInput && (
          <Controller
            name={inputName}
            control={control}
            rules={{ required: required ? `${inputLabel} es requerido` : false }}
            render={({ field }) => (
              <InputText
                {...field}
                name={inputName}
                control={control}
                label={inputLabel}
                error={errors[inputName]}
              />
            )}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          {cancelText}
        </Button>
        <Button 
          onClick={handleSubmit(onSubmitForm)} 
          variant="contained" 
          color="primary"
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}